export default {
    joinTitle: "加入我们一起愉快的工作吧",
    joinContent1: "整洁宽松的办公区、让你可以轻松高效的工作、休闲舒适的休息区、让你的生活充满乐趣",
    joinContent2: "完善的社会保障、住房公积金、带薪年假、带薪病假、工作所需的相关补助，如餐补等，年底的绩效奖金",
    joinContent3: "富有竞争力的薪酬保障、弹性的工作时间、五天工作日，每天8小时工作时间",
    joinJobsTitle: "岗位招聘",
    jobsName1: "数据工程师",
    jobsName2: "高级Python工程师",
    jobsName3: "高级前端工程师",
    jobsName4: "CV算法工程师",
    jobsName5: "高级数据科学家",
    jobsName6: "风控产品经理",
    jobsButton:"职位详情",
    jobsDetail1: [{
            h3: "岗位职责",
        },

        {
            p: "1. 研发图像处理和模型评估工具，服务于模型训练和数据分析，可视化任务;"
        },
        {
            p: "2. 与数据科学家团队紧密合作，用数据改进模型;"
        },
        {
            p: "3. 理解业务/产品需求并实现以数据挖掘技术支持产品增长;"
        },
        {
            p: "4. 管理图像数据仓库，构建数据平台;"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 计算机科学/信息技术/工程专业学士学位;"
        },
        {
            p: "2. 2年以上工作经验;"
        },
        {
            p: "3. 熟练掌握Python;"
        },
        {
            p: "4. 有使用基于云的分布式系统的经验;"
        },

        {
            p: "5. 热爱计算机视觉领域，有良好的学习态度;"
        },

        {
            p: "6. 具有团队合作精神，细致入微，对工作有较强的自主性。"
        }
    ],
    jobsDetail2: [{
            h3: "岗位职责",
        },

        {
            p: "1. 负责爬虫框架的设计和开发，实现对于多种数据源类型的支持，并保证灵活易用；"
        },
        {
            p: "2. 负责代理池的设计和开发，研究封锁和反封锁方案并实施；"
        },
        {
            p: "3. 负责具体网站和应用的信息抓取逻辑的开发；"
        },
        {
            p: "4. 负责线上系统的稳定高效运行，向公司内外部客户提供及时有效的技术支持。"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 统招本科以上学历，计算机或数学相关专业；"
        },
        {
            p: "2. 基础扎实，熟练掌握 Python，5年以上开发经验；"
        },
        {
            p: "3. 至少熟悉一种如Tornado 、Django 或 Flask 等 Python 框架；"
        },
        {
            p: "4. 熟悉 MySQL/MongoDB/Redis 等常用数据库及多线程编程，熟悉 Git/Svn 等常用的代码版本控制工具；"
        },

        {
            p: "5. 出色的逻辑思维能力和推动能力，以及良好的沟通协调能力，有良好的英文读写能力，有良好的英语口语能力优先；"
        },
        {
            p: "6. 对代码质量要求严格，遵循业界 Python 代码规范，有代码洁癖加分，重视 Code Review；"
        },
        {
            p: "7. 团队管理经验。"
        }
    ],
    jobsDetail3: [{
            h3: "岗位职责",
        },
        {
            p: "1. 负责官网和后台管理系统的开发和维护；"
        },
        {
            p: "2. 负责 Hybrid App 的开发和维护；"
        },
        {
            p: "3. 负责 Web App 的开发和维护，实现移动端适配。"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 热爱编程，学习能力够强；"
        },
        {
            p: "2. 掌握基本前端技能，熟悉 JS CSS 的使用；"
        },
        {
            p: "3. 掌握基础的 NodeJS 技能，能够使用 NodeJS 进行增删改查等操作；"
        },
        {
            p: "4. 熟悉 Vue 框架和技术栈。"
        },
        {
            h3: "加分项"
        },
        {
            p: "熟悉React或其他前端框架者优先"
        },
    ],
    jobsDetail4: [{
            h3: "岗位职责",
        },
        {
            p: "1. 负责图像识别算法的实现支撑风控业务, 包括物体检测，文本识别，人脸识别等。"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 硕士及以上学历，计算机相关方向；"
        },
        {
            p: "2. 熟悉深度学习算法以及一种机器学习框架 (Caffe/ TensorFlow)；"
        },
        {
            p: "3. 熟悉深度神经网络理论基础以及实战经验；"
        },
        {
            p: "4. 熟练python, c++；"
        },
        {
            p: "5. 具有良好的团队合作意识以及对技术饱有热情。"
        },
        {
            h3: "加分项"
        },
        {
            p: "参加过ACM, Topcoder或Hackathons，或有相关项目经验者优先考虑。"
        },
    ],
    jobsDetail5: [{
            h3: "岗位职责",
        },
        {
            p: "1. 利用海量数据构建信用评估模型;"
        },
        {
            p: "2. 对海量数据进行feature selection, combination等feature engineering工作；"
        },
        {
            p: "3. 搭建大规模机器学习算法平台。"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 具有信用风险管理相关的工作经验；"
        },
        {
            p: "2. 英文水平优秀，能顺畅地使用英文进行商务沟通；"
        },
        {
            p: "3. 对风控流程有一定的认识和理解，最好亲自开发过风控模型；"
        },
        {
            p: "4. 了解常用的风控建模方法，并能进行清晰准确的表达；"
        },
        {
            h3: "加分项"
        },
        {
            p: "1. 在相关A类会议（ICML, NIPS, SIGIR, SIGKDD等）第一作者发表论文；"
        },
        {
            p: "2. 参与过知名开源项目；"
        },
        {
            p: "3. 熟悉Apache spark；"
        },
        {
            p: "4. 对创业有激情。"
        },
    ],
    jobsDetail6: [{
            h3: "岗位职责",
        },
        {
            p: "1. 负责公司风控解决方案类产品的设计，全面规划风控产品矩阵的发展路线图；"
        },
        {
            p: "2. 全程参与技术团队大数据和风控平台的研发和测试流程；"
        },
        {
            p: "3. 负责外部数据源的评估接入、客户定制化风控解决方案的规划和实施；"
        },
        {
            p: "4. 开展海外市场和客户需求的调研，能根据不同市场的数据完备性、法律法规和客户认知水平设计有针对性的产品。"
        },
        {
            h3: "任职要求"
        },
        {
            p: "1. 2年以上甲方风控或风控产品经理经验，有银行及互联网相关背景优先；"
        },
        {
            p: "2. 具备初步的数据分析能力，学习能力强，具有主动意识，能够主动学习思考业务痛点及产品设计逻辑；"
        },
        {
            p: "3. 具有独立完成竞品调研，客户需求分析和撰写需求文档的能力；"
        },
        {
            p: "4. 有强烈的责任心和沟通、协调意识，能够明确提出和跟进项目中遇到的各种问题。"
        },
        {
            p: "5. 有一定的英语能力，能够用英语进行书面交流和撰写业务文档，海外留学背景优先；"
        },
        {
            p: "6. 富有创业精神，充满激情，具备创造性思维，乐于接受挑战。"
        },
    ],
}